import angular from "angular";
import mobiusError from "../mobius-error";
import core from "../../core/core.module";
import angularUIB from "angular-ui-bootstrap";
import errorHandlers from "../error-handlers/error-handlers";
import errorNotifications from "../error-notifications/error-notifications";

angular
    .module('mobiusControl.mobiusErrors', [mobiusError, core, angularUIB, errorHandlers, errorNotifications])
    .component('mobiusErrors', {
        template: require('./mobius-errors.html'),
        controller: ['MobiusError', 'notifier', '$uibModal', controller],
        bindings: {
            requests: '<'
        }
    });

function controller(MobiusError, notifier, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.currentPage = 1;

        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.onlyNotHandled = false;
        $ctrl.onlyNotNotify = false;

        $ctrl.getList();
    };

    $ctrl.filterChanged = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilters = function () {
        $ctrl.currentPage = 1;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        MobiusError
            .getList({
                currentPage: $ctrl.currentPage,
                errorType: $ctrl.errorType,
                errorCode: $ctrl.errorCode,
                errorMessage: $ctrl.errorMessage,
                requestSlug: $ctrl.requestSlug,
            })
            .then(
                function (response) {
                    $ctrl.mobiusErrors = response.data.mobiusErrors;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openHandlers = function (mobiusError) {
        $uibModal
            .open({
                component: 'errorHandlers',
                resolve: {
                    mobiusError: function () {
                        return mobiusError
                    }
                }
            });
    };

    $ctrl.openNotifications = function (mobiusError) {
        $uibModal
            .open({
                component: 'errorNotifications',
                resolve: {
                    mobiusError: function () {
                        return mobiusError
                    }
                }
            });
    }

}

export default "mobiusControl.mobiusErrors"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-errors/mobius-errors.js